import { render, staticRenderFns } from "./DashboardSideMenu.vue?vue&type=template&id=19b658ce&scoped=true&"
import script from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
export * from "./DashboardSideMenu.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSideMenu.vue?vue&type=style&index=0&id=19b658ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b658ce",
  null
  
)

export default component.exports